import get from "lodash/get";

export default function imagesMappedToUrls(imagesNodeList = []) {
  return imagesNodeList
    .map((n) => get(n, "image.file.url", "").replace(/^\/\//, "https://"))
    .filter((u) => u != null && u.length > 0);
}
